import { useSyncExternalStore, type FC } from "react";

import type { ErrorDialogStore } from "../mutation-feedback.store";
import { ErrorDialog } from "./error-dialog.component";

interface MutationFeedbackComponentOptions {
  app: string;
  store: ErrorDialogStore;
}

const createMutationFeedbackComponent = ({ app, store }: MutationFeedbackComponentOptions): FC => {
  const handleOpenChange = (open: boolean) => {
    if (!open) store.close();
  };

  const MutationFeedback: FC = () => {
    const { open, error } = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);

    return <ErrorDialog app={app} open={open} error={error} onOpenChange={handleOpenChange} />;
  };

  MutationFeedback.displayName = "MutationFeedback";

  return MutationFeedback;
};

export { createMutationFeedbackComponent };
